// Widget-Plugin: Stacked Chart
vcDashboardRegistry.register("stacked", {
    defaults: { w: 20, h: 12, resizable: true, copyable: true, showSettings: true, openSettingsOnCreate: true, pushOthers: false, category: "charts", get menuLabel() { return vcDashboardResources.get("menuCharts"); }, menuOrder: 3 },
    settingsDefaults: { SignalIds: [], IsCumulated: false, Interval: 0, ComparisonMode: 0, ComparisonOffset: -1, PriceCo2: 0, StackedType: 0 },
    get popupTitle() { return vcDashboardResources.get("stackedChartSettings"); },
    render: function ($container, item) {
        $container.html("<div class='dashboard-chart-wrapper'>" + item.title + "</div>");
    },
    buildParams: function (settings, status) {
        return vcDashboardPopup.buildChartParams(settings, status);
    },
    loadChart: function ($item, settings) {
        try {
            var resolved = vcDashboardPopup.resolveEffectiveSettings($item, settings);
            if (!resolved || !resolved.effectiveSettings) return;
            var obj = $item.find(".dashboard-chart-wrapper");
            if (!obj.length) {
                if (window.console && console.error) {
                    console.error("DashboardStacked loadChart failed: '.dashboard-chart-wrapper' not found.", {
                        itemId: $item.attr("data-item-id") || null
                    });
                }
                return;
            }
            obj.empty();
            obj.height($item.height() - 20);

            var params = this.buildParams(resolved.effectiveSettings, resolved.status);
            if (!params || !params.Param) return;

            //specific settings
            var stackedType = parseInt(resolved.effectiveSettings.StackedType, 10);
            params.Param.Extended = { StackedType: isNaN(stackedType) ? 0 : stackedType };
            

            obj.DashboardStacked({ invokeType: "addVisualBase", parameter: params.Param, signalParameter: params.SignalParam });
        } catch (e) {
            if (window.console && console.error) {
                console.error("DashboardStacked loadChart failed.", {
                    error: e,
                    message: e && e.message ? e.message : null
                });
            }
        }
    },
    onLoad: function ($item, settings) {
        this.loadChart($item, settings);
    },
    popupLayout: "twocolumn",
    buildFields: function (currentSettings, $el) {
        var signalOptions = vcDashboardPopup.getSignalOptions($el);
        var fields = [];
        if (signalOptions.length) {
            fields.push({ key: "SignalIds", label: vcDashboardResources.get("measurementPoint"), type: "signallist", options: signalOptions, column: "right" });
        }
        fields.push({ key: "Interval", label: vcDashboardResources.get("interval"), type: "select", options: [{value:0,text:vcDashboardResources.get("inheritFromMenu")},{value:1,text:vcDashboardResources.get("singleValues")},{value:2,text:vcDashboardResources.get("dailyValues")},{value:3,text:vcDashboardResources.get("monthlyValues")}], column: "left" });
        fields.push({ key: "ComparisonMode", label: vcDashboardResources.get("comparisonPeriod"), type: "select", options: [{value:0,text:vcDashboardResources.get("noComparison")},{value:1,text:vcDashboardResources.get("inheritFromMenu")},{value:2,text:vcDashboardResources.get("comparisonSpecific")}], column: "left" });
        fields.push({ key: "ComparisonOffset", label: "", suffix: vcDashboardResources.get("periods"), type: "number", dependsOn: { key: "ComparisonMode", value: 2 }, inline: true, column: "left" });
        //fields.push({ key: "IsCumulated", label: vcDashboardResources.get("cumulated"), type: "checkbox", column: "left" });
        fields.push({ key: "StackedType", label: vcDashboardResources.get("displayType"), type: "select", options: [{value:0,text:vcDashboardResources.get("percent")},{value:1,text:vcDashboardResources.get("absoluteValues")}], column: "left" });
        fields.push({ key: "PriceCo2", label: vcDashboardResources.get("priceCo2"), type: "select", options: [{value:0,text:vcDashboardResources.get("noSelection")},{value:1,text:vcDashboardResources.get("prices")},{value:2,text:vcDashboardResources.get("co2")}], column: "left" });
        return fields;
    },
    onSettingsSave: function ($el, newSettings) {
        this.loadChart($el, newSettings);
    },
    init: function ($item, settings) {
        vcDashboardPopup.initPlugin($item, this, settings);
    },
    resize: function ($item, settings) {
        this.loadChart($item, settings);
    }
});
